/* eslint-disable no-empty */
import type { ClickDataResponse } from 'server/internal/click-data';
import { pushEvent } from 'src/client/data-layer';

export enum TrackClickType {
  RAW = 'raw',
  OFFER = 'offer',
  SHOP = 'shop',
}
export enum TrackClickScope {
  PRICE_HISTORY = 'product_price_history',
  PRICE_LIST = 'product_price_list',
  PRICE_LIST_EXPANDED = 'product_price_list_expanded',
  SHOP_PAGE_HEADER = 'shop_page_header',
  SHOP_PAGE_ABOUT = 'shop_page_about',
  KEYWORD_PAGE = 'keyword_page',
  SEARCH_RESULT_PAGE = 'search_result_page',
  CAMPAIGN_SHOP_POPUP = 'campaign_shop_popup',
  CAMPAIGN_LIST_ITEM = 'campaign_list_item',
  USER_REVIEW_CARD = 'user_review_card',
}

async function fetchClickData(
  type: TrackClickType,
  id: string
): Promise<ClickDataResponse | Record<string, any>> {
  if (!id) return {};

  try {
    // We need to await this here in order to catch rejected fetch-promises
    const res = await fetch(`/_internal/click-data/${type}/${id}`);
    return res.json();
  } catch (error) {
    // Fail silently in case of adblocker
    return {};
  }
}

export type TrackClickWithRevenueData = {
  scope: TrackClickScope;
};
export type TrackOfferClickWithRevenueData = TrackClickWithRevenueData & {
  offerId: string;
  productId?: number;
};
export type TrackShopClickWithRevenueData = TrackClickWithRevenueData & {
  shopId: number;
};

export const trackOfferClickWithRevenue = async (
  data: TrackOfferClickWithRevenueData
) => {
  const { offerId } = data;
  const isRawOffer = typeof offerId === 'string' && offerId.includes('-');
  let clickData;
  try {
    clickData = await fetchClickData(
      isRawOffer ? TrackClickType.RAW : TrackClickType.OFFER,
      offerId
    );
  } catch (error) {}
  pushEvent(isRawOffer ? 'rawOfferClickWithRevenue' : 'offerClickWithRevenue', {
    ...data,
    ...clickData,
  });
};

export const trackShopClickWithRevenue = async (
  data: TrackShopClickWithRevenueData
) => {
  let clickData;
  try {
    clickData = await fetchClickData(TrackClickType.SHOP, String(data.shopId));
  } catch (error) {}
  pushEvent('shopClickWithRevenue', { ...data, ...clickData });
};
